import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarLocationFilterDropdownContent from './VeltCommentsSidebarLocationFilterDropdownContent/VeltCommentsSidebarLocationFilterDropdownContent';
import VeltCommentsSidebarLocationFilterDropdownTrigger from './VeltCommentsSidebarLocationFilterDropdownTrigger/VeltCommentsSidebarLocationFilterDropdownTrigger';
var VeltCommentsSidebarLocationFilterDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarLocationFilterDropdown.Trigger = VeltCommentsSidebarLocationFilterDropdownTrigger;
VeltCommentsSidebarLocationFilterDropdown.Content = VeltCommentsSidebarLocationFilterDropdownContent;
export default VeltCommentsSidebarLocationFilterDropdown;
